import React from 'react';

interface LogoSVGProps {
  size?: number;
  color?: string;
  segment?: number | 'all';
  className?: string;
  style?: React.CSSProperties;
}

export function LogoSVG({
  size = 40,
  color = '#F58406',
  segment = 'all',
  className = '',
  style = {},
}: LogoSVGProps) {
  const segments = [];
  const c = 50;
  const r1 = 30;
  const r2 = 46;

  const polarToCartesian = (r: number, angleDegrees: number) => {
    const angleRadians = (angleDegrees * Math.PI) / 180;
    return [c + r * Math.cos(angleRadians), c + r * Math.sin(angleRadians)];
  };

  for (let i = 0; i < 8; i++) {
    const a0 = i * 45 + 3;
    const a1 = i * 45 + 42;
    const [x0, y0] = polarToCartesian(r2, a0);
    const [x1, y1] = polarToCartesian(r2, a1);
    const [x2, y2] = polarToCartesian(r1, a1);
    const [x3, y3] = polarToCartesian(r1, a0);

    const active = segment === 'all' || segment === i;
    const d = `M${x0} ${y0} A${r2} ${r2} 0 0 1 ${x1} ${y1} L${x2} ${y2} A${r1} ${r1} 0 0 0 ${x3} ${y3} Z`;

    segments.push(
      <path
        key={i}
        d={d}
        fill={active ? color : '#2E2E35'}
        className={active ? '' : 'lg-off'}
        opacity={active ? 1 : 0.9}
      />
    );
  }

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      style={{ flex: 'none', ...style }}
    >
      <defs>
        <radialGradient id={`lg-${size}`} cx="50%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#FFAE3D" />
          <stop offset="100%" stopColor="#F58406" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="49" className="lg-bg" fill="#141416" />
      {segments}
      <circle cx="50" cy="50" r="22" className="lg-core" fill="#0B0B0C" />
      <circle
        cx="50"
        cy="50"
        r="11"
        fill={segment === 'all' || segment !== undefined ? color : '#3a3a40'}
      />
    </svg>
  );
}
